import { render } from "./widgetWeatherStats.vue?vue&type=template&id=583342e7&scoped=true"
import script from "./widgetWeatherStats.vue?vue&type=script&lang=js"
export * from "./widgetWeatherStats.vue?vue&type=script&lang=js"

import "./widgetWeatherStats.vue?vue&type=style&index=0&id=583342e7&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583342e7"]])

export default __exports__